module.exports = __webpack_public_path__ + "static/media/lod-micro.17092463.svg";